import { mapGetters } from 'vuex'

import FORM_CONSTANTS from '@/js/components/Forms/ComplaintForm/_store-module/constants.js'
import FORM_GETTER from '@/js/components/Forms/ComplaintForm/_store-module/getter-types.js'

export default {
  computed: {
    ...mapGetters(FORM_CONSTANTS.STORE_ID, {
      stateImageData: FORM_GETTER.IMAGE_DATA,
    }),
    imageData() {
      return this.stateImageData.reduce((acc, data) => ({ ...acc, [data.name]: data }), {})
    },
  },
}
